import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Travel  = () => {

  const  servicesFaqData = [
    { 
        question: "What is travel printing, and what materials are included?     ", 
        answer: "Travel printing involves creating high-quality materials such as brochures, standees, leaflets, and promotional items tailored for the travel industry. It includes printing travel brochures highlighting destinations, packages, and services in a visually appealing format. Promotional materials like standees and leaflets attract attention at events, travel fairs, and storefronts. Travel printing also includes innovative solutions like 3D printing for travel, which produces custom accessories and product prototypes. These materials help travel firms and agencies connect with customers effectively and promote their services."
    },
    { 
        question: "What are the benefits of custom travel brochures and standees printing?  ", 
        answer: "Custom printing travel brochures and standees allows travel businesses to create visually engaging materials that reflect their brand and services. Brochures provide detailed information about destinations and packages, serving as a powerful marketing tool. Standees attract customer attention with vibrant visuals and compelling messaging, making them ideal for events and promotional campaigns. High-quality materials and printing techniques enhance the professional appearance of these items, ensuring a strong brand presence. Customised brochures and standees also help build customer trust and drive bookings."
    },
    { 
        question: "Can Printingy handle bulk orders for travel printing services?  ", 
        answer: "Yes, Printingy specialises in bulk printing for travel firm solutions, offering cost-effective services for large-scale promotional needs. Bulk printing reduces per-unit costs, making it ideal for travel agencies, tourism boards, and event organisers. Our advanced technology ensures consistent quality across all materials, regardless of the order size. We also provide quick turnaround times, ensuring that your brochures, standees, and promotional items are ready for distribution on schedule. Printingy’s reliable bulk printing services help streamline marketing efforts and enhance brand visibility."
    },
    { 
        question: "What materials are used for travel brochures and promotional printing?  ", 
        answer: "Our travel brochures and promotional materials are printed using premium materials such as high-gloss paper, matte finishes, and weather-resistant options. The high-gloss paper ensures vibrant colours and sharp details, making brochures visually engaging. Matte finishes provide a professional look for promotional materials like leaflets and standees. Weather-resistant materials are perfect for outdoor displays, ensuring durability in various conditions. These materials are selected to meet the unique requirements of the travel industry, delivering quality and impact for all printed items.."
    },
    { 
        question: "What industries and businesses benefit from travel printing services?  ", 
        answer: "Travel agencies, tour operators, and tourism boards benefit significantly from printing for travel industry services. Agencies use brochures, standees, and promotional leaflets to attract customers and showcase their offerings. Tour operators rely on these materials to communicate itineraries, highlight destinations, and promote packages. Tourism boards utilise custom printing solutions for large-scale events, travel fairs, and branding initiatives. These services provide effective marketing and customer engagement tools, making them essential for the travel industry."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Automotive');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Professional Travel Printing Services"
  description="High-quality printing for the travel industry, including brochures, standees, and promotional materials. Bulk printing for travel firms and 3D printing for travel solutions."
  keywords="Printing for Travel Industry,
Printing for Travel Firm,
3D Printing for Travel,
Printing Travel Brochures,
Printing Travel Standees,
Printing Travel Leaflets,
Printing Travel Promotions
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for the Travel Industry  </h1>
              <h2 className="text-muted">Customised printing solutions for travel brochures, standees, and promotions</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Travel businesses rely on impactful printing to attract customers, showcase destinations, and promote services effectively. Printingy specialises in Printing for Travel Industry, offering high-quality printing for travel firm solutions tailored for agencies, tour operators, and travel firms.</p>
          <p>Our services include printing travel brochures and creating vibrant and informative materials to highlight destinations and packages. We deliver printing travel standees and promotional leaflets for marketing campaigns to capture customer attention. Our 3D printing for travel also provides innovative solutions, such as custom travel accessories and product prototypes, enhancing customer experience.</p> 
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Travel Printing Solutions  </h2>
                <h3 className="large-hed">High-quality, durable printing for travel promotions and branding  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing for the Travel Industry tailored for promotions and branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing for travel firm solutions with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant printing of travel brochures for effective marketing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Customised printing travel standees to attract customer attention.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced 3D printing for travel for innovative product solutions.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials for leaflets, brochures, and promotional displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for travel firms, agencies, and tourism boards.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/travelprinting.jpg" // Path relative to the public folder
                  alt="Professional printing for the travel industry services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Travel Printing Delivered On Time  </h2>
            <h3 className="small-hed">Focus on your travel services while we handle your printing needs  </h3>
            <p>At Printingy, we combine cutting-edge printing technology with premium materials to deliver exceptional printing for travel industry solutions. From brochures and leaflets to standees and custom travel accessories, our services ensure professional and visually impactful results.
            </p>
            <p>With a commitment to quality and efficiency, Printingy guarantees timely delivery for all bulk and customised orders. Partner with us for reliable, innovative printing solutions tailored to the travel industry.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Travel;
